import { render, staticRenderFns } from "./CategoriaViaticoPage.vue?vue&type=template&id=dc299d1a"
import script from "./CategoriaViaticoPage.js?vue&type=script&lang=js&external"
export * from "./CategoriaViaticoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports